export default __webpack_public_path__ + "static/google-ratings-image-5ca2edee52957c949e186de8a2c10ea0.png";